@if (!isLoading) {
  <mat-card appearance="outlined">
    <mat-card-title>Gérer mes entreprises</mat-card-title>
    @if (listJsonCompanies?.length >= 1) {
      <table mat-table [dataSource]="listJsonCompanies" class="mat-elevation-z0">
        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef></th>
          <td class="center pointer" mat-cell *matCellDef="let element"
            (click)="switchCompany(element.siret, element.auxiliaire, element.tiers)">
            @if (element.tiers !== '' && element.tiers) {
              <span> {{ element.tiers }} - </span>
              }{{ element.raisonSociale }}
              @if (element.siret !== null && element.siret !== '') {
                <span> - {{ element.siret }}</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>Supprimer</th>
            <td (click)="delete(element)" *matCellDef="let element" class="center" mat-cell>
              <mat-icon>delete</mat-icon>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      }
      @if (listJsonCompanies?.length < 1) {
        <p>
          Vous n'avez aucune entreprise enregistrée.
        </p>
      }
      <form class="new_company" [formGroup]="formAddNewCompany" (ngSubmit)="addNewCompany()">
        <mat-form-field>
          <mat-label>Siret ou code client</mat-label>
          <input [(ngModel)]="companyValue" matInput formControlName="company">
          @if (formAddNewCompany.get('company').hasError('required')) {
            <mat-error>
              Le numéro de SIRET/code client est requis
            </mat-error>
          }
        </mat-form-field>
        <p>
          <button class="space_button" mat-button [disabled]="formAddNewCompany.get('company').errors">Ajouter cette entreprise</button>
        </p>
      </form>
    </mat-card>
  }
  @if (isLoading) {
    <mat-card appearance="outlined">
      <mat-card-title>Chargement de vos entreprises</mat-card-title>
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </mat-card>
  }
